const trackerProperties = {
  content_id: "kre8-stats-tracker",
  content_name: "Kre8 Social Media Stats Tracker",
  content_type: "product",
  currency: "USD",
  value: 10,
};

export function trackTikTokStatsEvent(event) {
  if (typeof window === "undefined" || typeof window.ttq?.track !== "function") return;
  window.ttq.track(event, trackerProperties);
}
